<template>
    <div
        class="radio-field"
		:class="{'radio-field--error' : error}"
        @change="$emit('input', $event.target.value)"
    >
        <span class="radio-field__desc">{{ label }}</span>

        <template v-for="option of options">
            <input
                :id="`${fieldId}-${option.value}`"
                :key="option.value"
                v-model="picked"
                type="radio"
                class="d-none"
                :value="option.value"
            >
            <label
                :key="option.title"
                class="radio-field__label"
                :for="`${fieldId}-${option.value}`"
            >{{ say[option.title] || option.title }}</label>
        </template>

        <span
            class="input-error"
            :class="{'input-error--show' : error}"
        >{{ say[error] }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import input from '@/mixins/input';

export default {
    mixins: [input],
    props: {
        options: {
            // [ { value: String, title: String }, ... ]
            type: Array,
            required: true,
        },
        name: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            picked: this.value,
        };
    },
    computed: {
        ...mapGetters(['say']),
        fieldId() {
            return this.name || `radio-${this._uid}`;
        },
    },
};
</script>
